import React, { useEffect, useState, useRef } from 'react';

import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';

import { getWeekPeriodByDate, getWeekPeriodString, dateToYYYYMMDD } from '../../../helpers/datetime';

import { setPeriodAction, setRecordsAction } from '../../../store/recordsTableReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';

import "./PeriodSelector.scss"

const PeriodSelector = () => {
	const dropdown = useRef()
	const dispatch = useDispatch()
	const [open, setOpen] = useState(false);
	const [periodValue, setPeriodValue] = useState(false);
	const [value, setValue] = useState('');

	const clinic = useSelector(state => state.recordsTable.clinic)

	useEffect(() => {
		updatePeriod(new Date())
	}, [])

	const onChange = (value, event) => {
		updatePeriod(value)
		setOpen(false)
	}

	const updatePeriod = (date) => {
		const weekRange = getWeekPeriodByDate(date)
		setPeriodValue(weekRange)
		const periodString = getWeekPeriodString(weekRange)
		setValue(periodString)

		const periodArray = [dateToYYYYMMDD(weekRange[0]), dateToYYYYMMDD(weekRange[1])];
		dispatch(setPeriodAction(periodArray));
		if(clinic) fetchRecords(clinic, periodArray)
	}

	const [fetchRecords] = useFetching(async (clinic, period) => {
		const response = await PostService.getRecordsByPeriod(clinic, period)
		if (response.data.success && response.data.result !== false) {
			dispatch(setRecordsAction(response.data.result))
		}
	})

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandlerPeriodSelector);
		},[0])

		return () => document.removeEventListener('click', documentClickHandlerPeriodSelector);
	}, []);

	const documentClickHandlerPeriodSelector = (e) => {
		if(!dropdown.current) return;
		if(!dropdown.current.contains(e.target)){
			setOpen(false)
		}
	};

	return (
		<div className={"period-selector" + (open ? " open" : "")} ref={dropdown}>
			<button className="period-selector__btn" onClick={() => setOpen(!open)}>{value}</button>
			<div className="period-selector__dropdown">
				<Calendar
					onChange={onChange}
					value={periodValue}
					className={'period-selector__calendar'}/>
			</div>
		</div>
	);
};

export default PeriodSelector;
